import { MouseEvent as ReactMouseEvent, useLayoutEffect, useRef } from 'react'

interface UseStepperScrollBehaviorProps {
  activeStep: number
  scrollContainerSelector?: string
}

export const useStepperScrollBehavior = ({
  activeStep,
  scrollContainerSelector = '[data-form-step-scroll]',
}: UseStepperScrollBehaviorProps) => {
  const isInitialRenderRef = useRef(true)
  const stepperAnchorRef = useRef<HTMLDivElement>(null)

  const scrollToTopInstant = () => {
    const layoutScrollContainer = document.querySelector<HTMLElement>(
      '[data-scroll-container]'
    )
    if (layoutScrollContainer) {
      layoutScrollContainer.scrollTop = 0
      layoutScrollContainer.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    }

    stepperAnchorRef.current?.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      behavior: 'auto',
    })

    const scrollContainers = document.querySelectorAll<HTMLElement>(
      scrollContainerSelector
    )
    scrollContainers.forEach(container => {
      container.scrollTop = 0
    })

    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0
    }
  }

  useLayoutEffect(() => {
    if (isInitialRenderRef.current) {
      isInitialRenderRef.current = false
      return
    }

    scrollToTopInstant()
    const rafId = requestAnimationFrame(scrollToTopInstant)
    const timeoutId = window.setTimeout(scrollToTopInstant, 0)

    return () => {
      cancelAnimationFrame(rafId)
      clearTimeout(timeoutId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep, scrollContainerSelector])

  const preventButtonFocusOnMouseDown = (e: ReactMouseEvent<HTMLElement>) => {
    e.preventDefault()
  }

  const blurActiveElement = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur()
    }
  }

  return {
    stepperAnchorRef,
    preventButtonFocusOnMouseDown,
    blurActiveElement,
  }
}
